import './MilestonePopUp.css';
import updateUserData from '../../../assets/functions/updateUserData';
import React from "react";

function MilestonePopUp(props) {

    function handleChangeMilestone() {
      let placeholderGoalList = [...props.userProfile.goals]
      let milestoneUpdatedText=props.associatedMilestone+"&"
      for (const [index, goal] of props.userProfile.goals.entries()) {
        if (goal.goalType === "milestone" && goal.milestones.includes(props.associatedMilestone)) {
            let milestonesPlaceholder = [...goal.milestones]
            console.log(milestonesPlaceholder)
            let indexToChange = milestonesPlaceholder.indexOf(props.associatedMilestone)
            console.log(indexToChange)
            milestonesPlaceholder[indexToChange] = milestoneUpdatedText
            let goalToChange ={...placeholderGoalList[index]}
            goalToChange.milestones=milestonesPlaceholder
            placeholderGoalList[index]=goalToChange
      }}
      updateUserData("updateGoal", placeholderGoalList, props.userProfile, props.setUserProfile, props.resetShowTaskMilestone)
    }

    return (
        <div className="milestonePopUp">
            <p className="closePopUpText" onClick={()=> props.resetShowTaskMilestone()}> close milestone popup</p>
            <p> milestone: {props.associatedMilestone} </p>
            <p onClick={()=> handleChangeMilestone()} className="milestonePopUpButton"> mark milestone as completed</p>
            <p onClick={()=> props.setShowAddTask(true)} className="milestonePopUpButton"> add a task for this milestone</p>
        </div>
    )
}

export default MilestonePopUp;